import { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const menuItems = [
    { name: 'Startseite', path: '/' },
    { name: 'Über Uns', path: '/uber-uns' },
    { name: 'Leistungen', path: '/leistungen' },
    { name: 'Wohnnetzwerk', path: '/wohnnetzwerk' },
    { name: 'FAQ', path: '/faq' },
    { name: 'Kontakt', path: '/kontakt' }
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/30 backdrop-blur-lg border-b border-white/10">
      <nav className="container-custom py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img src="/logo.png" alt="Angel & Devil Network" className="h-16" />
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            {menuItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className="text-white hover:text-hot-pink transition-colors"
              >
                {item.name}
              </Link>
            ))}
            <Link 
              to="/bewerbung" 
              className="btn-primary"
            >
              JETZT STARTEN
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className="w-6 h-6"
            >
              {isMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>

          {/* Mobile Navigation */}
          <nav className={`absolute top-full left-0 w-full bg-deep-black/95 backdrop-blur-md py-4 ${
            isMenuOpen ? 'block' : 'hidden'
          }`}>
            <div className="container-custom flex flex-col space-y-4">
              {menuItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  className="text-white hover:text-hot-pink transition-colors"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
              <Link 
                to="/bewerbung" 
                className="btn-primary text-center"
                onClick={() => setIsMenuOpen(false)}
              >
                JETZT STARTEN
              </Link>
            </div>
          </nav>
        </div>
      </nav>
    </header>
  );
};

export default Header;
